import { Link } from "react-router-dom";
function Aboutus() {
  return (
    <>
      <div className="innerslide py-3 bg-light border-bottom">
        <h1>About Us</h1>

        <ul className="breadcrumb container mb-0">
          <li className="breadcrumb-item">
            <Link to="/">Home</Link>
          </li>
          <li className="breadcrumb-item">About</li>
          <li className="breadcrumb-item active">About Us</li>
        </ul>
      </div>

      <div className="innersec container my-5 founder_message">
        <div className="row">
          <div class="col-lg-12">
            <h1> About Us </h1>
            <p>The Frank Anthony Junior School, Bengaluru, is a reputed educational
              institutions in the city, established in 1971 by the late Mr. Frank Anthony.
              The school has a rich legacy of excellence in education and holistic
              development.</p>

            <p>Mr. Frank Anthony was a distinguished national leader, legal luminary,
              and educationist. He served as a Member of the Constituent Assembly
              from 1942 and was a Member of Parliament (Lok Sabha) for nearly five
              decades. A Barrister-at-Law from the Inner Temple, London, he was also a
              renowned Senior Advocate of the Supreme Court of India. His invaluable
              contributions to education and the welfare of the Anglo-Indian community
              continue to inspire generations.</p>
            <p>The Frank Anthony Junior School, Bengaluru, is an unaided minority
              educational institution established, owned, and administered by The
              All-India Anglo-Indian Education Institution. The Institution also owns
              and administers the The Frank Anthony Public School, New Delhi, The
              Frank Anthony Public School, Kolkata, The Frank Anthony Public School,
              Bengaluru, and The Frank Anthony Junior School, Bengaluru.</p>
            <p>The school is affiliated with Council for the Indian School Certificate
              Examinations (ICSE), one of India’s premier examination boards. Mr.
              Frank Anthony was the Founder and first elected Chairman of the Council,
              and his vision continues to guide the institution’s pursuit of educational
              excellence. The Presidents of The All-India Anglo-Indian Education
              Institution, and Chairmen of the Board of Governors of The Frank
              Anthony Public Schools, Delhi, Kolkata and Bengaluru are mentioned
              chronologically below:</p>


            <ul class="leadership-list">
              <li>
                <strong>Mr. Frank Anthony</strong>, Barrister-at-Law, M.P.
                <span>1958 – 2nd December, 1993</span>
              </li>

              <li>
                <strong>Maj. Gen. (Retd.) R. G. Williams</strong>, PVSM, M.P.
                <span>3rd December, 1993 – July, 1998</span>
              </li>

              <li>
                <strong>Mr. Neil O’Brien</strong>, Ex-M.P.
                <span>July, 1998 – June, 2016</span>
              </li>

              <li>
                <strong>Air Marshal (Retd.) Denzil Keelor</strong>, PVSM, KC, AVSM, VrC
                <span>June, 2016 – October, 2021</span>
              </li>

              <li>
                <strong>Dr. Peter Fanthome</strong>, D.Litt, M.A., B.Ed., T.T.C., Ex-MLA
                <span>October, 2021 – December, 2022</span>
              </li>

              <li>
                <strong>Mr. David J. Hilton</strong>, M.A., B.Ed., T.T.C.
                <span>December, 2022 – Present</span>
              </li>
            </ul>
            <p>The Frank Anthony Junior School, Bengaluru, is a co-educational day
              school committed to providing an all-round, holistic education. The school
              strives to ensure that students excel not only in academics but also in
              co-curricular and extracurricular activities, while developing essential
              leadership qualities and strong moral values.</p>
            <p>The institution is supported by a dedicated and highly qualified faculty and
              is equipped with modern infrastructure and well-maintained laboratories
              that facilitate high standards of teaching and learning. The school
              provides a safe, nurturing, and stimulating environment that promotes the
              intellectual, emotional, social, and physical development of every child.</p>

            <p>Over the years, The Frank Anthony Junior School, Bengaluru, is known
              for maintaining high standards of discipline, academic excellence, and
              outstanding achievements in both curricular and co-curricular activities.
              The school remains committed to fostering integration in education,
              preserving educational standards, and serving society by providing quality
              education to students from all communities from Pre-Nursery to Class X.</p>
            <p>Guided by its enduring motto,<b>“COURAGE IS DESTINY,”</b> the
              school continues its mission of nurturing responsible, confident, and
              compassionate citizens of tomorrow.</p>

          </div>
        </div>

        <div class="row">
          <div class="clearfix">
            <div class="motto">
              <h4> Our Motto</h4>
              <div class="mottoquotes">
                <p> Courage Is Destiny</p>
              </div>
            </div>
            <div class="table-responsive boardmember">
              <table class="table">
                <thead>
                  <tr>
                    <th colspan="2" style={{color:"white"}}>School Hours</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td colspan="2">
                      <b> Monday To Friday</b>{" "}
                    </td>
                  </tr>
                  <tr>
                    <td>Pre-Nursery to Preparatory - 7:55 to AM 12:00 Noon</td>
                  </tr>
                  <tr>
                    <td>Std I & II - 7:55 AM to 12:30 PM</td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      {" "}
                      <b>(Break) - 30 Minutes</b>
                    </td>
                  </tr>
                  <tr>
                    <td>Std III to V - 7:55 AM to 1:30 PM</td>
                  </tr>
                  <tr>
                    <td>Std VI to X - 7:55 AM to 2:00 PM</td>
                  </tr>
                  {/* 
                  <tr>
                    <td> Classes 8 to 12 - 07.55 A.M to 02.00 P.M.</td>
                  </tr>
                  <tr>
                    <td> Classes 3 to 7 - 07.55 A.M to 01.25 P.M.</td>
                  </tr>
                  <tr>
                    <td colspan="2"> <b>(Break) - 30 Minutes</b></td>
                  </tr>
                  <tr>
                    <td> Nursery to Class 2 - 07.55 A.M to 12.05 P.M.</td>
                  </tr>
                  <tr>
                    <td> Pre-Nursery - 07.55 A.M to 11.00 A.M</td>
                  </tr> */}
                </tbody>
              </table>
            </div>
            <div class="aboutschool">
              <p class="innerhead">
                <u> Medium of Instruction:</u> <span> English</span>{" "}
              </p>
              <p class="innerhead">
                <u> Languages Taught:</u> <span> English, Hindi, Kannada</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Aboutus;
